module.exports = __webpack_public_path__ + "static/media/julesMapPlane.fbf9796d.png";